import { FC, useContext, useEffect, useRef } from 'react';

import { Modal } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import notificationService from 'services/notificationService';
import { convertSignCode } from 'utils';

import { keysMap } from './constants';
import s from './HonestSign.module.scss';
import { ESignModalType } from './index';

interface IHonestSignModalProps {
  onScan: (sign: string) => void;
  onCancel: VoidFunction;
  validator: (code: string) => Promise<{
    validate: boolean;
    errorMessage?: string;
  }>;
  type: ESignModalType;
}

export const HonestSignModal: FC<IHonestSignModalProps> = ({
  onScan,
  onCancel,
  validator,
  type,
}) => {
  const { t } = useContext(LocalizationContext);
  const inputValue = useRef<string>('');
  useEffect(() => {
    const listener = (e: MouseEvent): void => e.preventDefault();

    window.addEventListener('mousedown', listener);

    return () => window.removeEventListener('mousedown', listener);
  }, []);

  return (
    <Modal onClose={onCancel} rootId="code-check">
      <div className={s.container}>
        <header className={s.title}>
          Отсканируйте &quot;Честный ЗНАК&quot;
        </header>
        <div className={s.message}>
          {type === ESignModalType.ADD
            ? 'Для добавления товара в корзину '
            : 'Для удаления товара из корзины '}
          - отсканируйте маркировку &quot;Честный ЗНАК&quot;
        </div>
        <input
          name="sign"
          ref={(instance) => instance?.focus()}
          autoComplete="off"
          onKeyDown={async (event) => {
            if (event.key === 'Enter') {
              const { parsedStr } = convertSignCode(inputValue.current);

              const isValid = await validator(parsedStr);

              if (!isValid.validate) {
                inputValue.current = '';

                return notificationService.info({
                  t,
                  type: 'warning',
                  title: isValid.errorMessage
                    ? 'Некоректный честный знак'
                    : 'Некорректный код',
                  message:
                    isValid.errorMessage ??
                    'Отсканируйте маркировку "Честный ЗНАК"',
                });
              }

              onScan(parsedStr);
            }

            const codeValue = keysMap[event.code];

            if (!codeValue) {
              return;
            }

            inputValue.current += event.shiftKey
              ? codeValue.withShift
              : codeValue.normal;
          }}
          className={s.input}
        />
      </div>
    </Modal>
  );
};
